import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader } from "src/components/layout";
import { sessionToken } from "src/services/authService";
import { useLoginContext } from "src/contextApi/LoginContext";
import { saveToLocal } from "src/util/cache.service";
import { LOCAL_KEYS } from "src/util/util.constant";
import { ROUTE_CONSTANTS } from "./routeConstant";
import Notification from "src/util/libs/notification";

interface TokenHandlerProps {
  children: React.ReactNode;
}

const TokenHandler: React.FC<TokenHandlerProps> = ({ children }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setToken } = useLoginContext();
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      navigate(ROUTE_CONSTANTS.LOGIN);
      return;
    }

    const exchangeToken = async () => {
      try {
        const { data } = await sessionToken({ token });
        const { token: tokenData, role, details } = data.response;
        const accessToken = tokenData.access_token;
        const refreshToken = tokenData.refresh_token;

        setToken(accessToken);
        saveToLocal(LOCAL_KEYS.TOKEN, accessToken, false, true);
        saveToLocal(LOCAL_KEYS.REFRESH_TOKEN, refreshToken, false, true);
        saveToLocal(LOCAL_KEYS.IS_AUTHENTICATED, true, false, true);
        saveToLocal(LOCAL_KEYS.ROLE, role ?? "", false, true);
        if (details) {
          saveToLocal(LOCAL_KEYS.USER_DETAIL, details, true, true);
        }
        navigate(ROUTE_CONSTANTS.DASHBOARD);
      } catch {
        Notification.error({
          message: "Session error",
          description: "Invalid or expired token",
        });
        navigate(ROUTE_CONSTANTS.LOGIN);
      }
    };

    exchangeToken();
  }, [token, navigate, setToken]);

  if (token) {
    return <Loader height="h-screen" />;
  }

  return <>{children}</>;
};

export default TokenHandler;
